// extracted by mini-css-extract-plugin
export var chevron = "_jd-3";
export var chevronRotated = "_jd-4";
export var image = "_jd-1";
export var imageContainer = "_jd-0";
export var shippingAddress = "_jd-2";